import { ExternalBankAccount } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { Form } from "./Form";
import { ManualAccountSubType, ManualAccountType } from "./types";
import { useMutationSubmit } from "./useMutationSubmit";

type FormManuallyAddAccountProps = {
  rtpRequired?: boolean;
  onBack?: () => void;
  onSuccess?: (externalBankAccount: ExternalBankAccount) => void;
  submitButtonText?: string;
  setStandardPayoutDestination?: boolean;
  setInstantPayoutDestination?: boolean;
  setDefaultPaymentMethod?: boolean;
  setFundingSource?: boolean;
  requestVerification?: boolean;
  hideAccountHolderName?: boolean;
  withPanel?: boolean;
  type?: ManualAccountType;
  subType?: ManualAccountSubType;
};

export const FormManuallyAddAccount: React.FC<
  FormManuallyAddAccountProps
> = props => {
  const hideAccountHolderName =
    props.hideAccountHolderName ??
    !!(props.setStandardPayoutDestination || props.setInstantPayoutDestination);

  const [submit, submitMeta] = useMutationSubmit(
    {
      setStandardPayoutDestination: props.setStandardPayoutDestination,
      setInstantPayoutDestination: props.setInstantPayoutDestination,
      requestVerification: props.requestVerification,
      setDefaultPaymentMethod: props.setDefaultPaymentMethod,
      setFundingSource: props.setFundingSource,
      hideAccountHolderName,
      type: props.type,
      subType: props.subType
    },
    { onSuccess: props.onSuccess }
  );

  return (
    <Form
      rtpRequired={props.rtpRequired}
      onSubmit={submit}
      submitButtonText={props.submitButtonText}
      error={submitMeta.error}
      isLoading={submitMeta.isLoading}
      withPanel={props.withPanel}
      onBack={props.onBack}
      typeProvided={!!props.type}
      hideAccountHolderName={hideAccountHolderName}
    />
  );
};
